

const Footer = () => {
  return (
    <div className="max-w-screen-xl mx-auto p-4 text-center bg-custom-gradient-1 dark:bg-custom-gradient-2 dark:text-white">
      <p className="text-sm mb-2">Made With Love By <a className="dark:text-primary text-white" href="https://www.fiverr.com/jessicamorris5" target="_blank" rel="noreferrer">Jessica!</a> </p>
      <p>Copyright © 2024 Studio Mercy.</p>
    </div>
  )
}

export default Footer